import { render, staticRenderFns } from "./ChatSummaryCard.vue?vue&type=template&id=3cb3b2ed&scoped=true"
import script from "./ChatSummaryCard.vue?vue&type=script&lang=js"
export * from "./ChatSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./ChatSummaryCard.vue?vue&type=style&index=0&id=3cb3b2ed&prod&scoped=true&lang=css"
import style1 from "./ChatSummaryCard.vue?vue&type=style&index=1&id=3cb3b2ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb3b2ed",
  null
  
)

export default component.exports